function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, Children, isValidElement, cloneElement } from "react";
import { Flex } from "sprout-ui-primitives";
const TabList = (props)=>{
    const { children , index , onChange  } = props, rest = _objectWithoutProperties(props, [
        "children",
        "index",
        "onChange"
    ]);
    const tabItems = useMemo(()=>{
        return Children.map(children, (child, childIndex)=>{
            if (!/*#__PURE__*/ isValidElement(child)) return undefined;
            const onClick = (event)=>{
                onChange(event, childIndex);
            };
            return /*#__PURE__*/ cloneElement(child, {
                selected: index === childIndex,
                onClick
            });
        });
    }, [
        children,
        index,
        onChange
    ]);
    return /*#__PURE__*/ _jsx(Flex, _objectSpread({
        height: "48px",
        alignItems: "center"
    }, rest, {
        children: tabItems
    }));
};
export default TabList;
